<div [formGroup]="form" class="mb-3">
  <label 
    [class.field-invalid]="form.get(controlName)?.invalid && form.get(controlName)?.touched"
    [class.field-valid]="form.get(controlName)?.valid && form.get(controlName)?.touched && !isFocused(controlName)"
    [class.field-focused]="form.get(controlName)?.valid && isFocused(controlName)"
    [ngClass]="isReFill ? 'label-refill' : ''"
    [for]="controlName">
    {{label}}
  </label>

  <div id="general-input-group" class="input-group ">
    <input 
      *ngIf="!isMoney"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [id]="controlName"
      [class.input-invalid]="form.get(controlName)?.invalid && form.get(controlName)?.touched" 
      [formControlName]="controlName" 
      type="text" 
      class="form-control"
      [ngClass]="{
        'icono-placeholder-image': form.get(controlName)?.invalid && form.get(controlName)?.touched,
        'text-invalid': form.get(controlName)?.invalid && form.get(controlName)?.touched,
        'input-editable': isEditable,
        'input-empty': form.get(controlName)?.value === ''
      }"
      [placeholder]="placeholder" 
      [readonly]="isReadOnly" 
      (keydown)="isNumberOnly ? validateNumber($event) : (isAlphaOnly ? validateAlpha($event) : (isEmail ? blockUnicode($event) : null) )" 
      (input)="isNumberOnly ? onInput($event) : (isAlphaOnly ? onInput($event,false) : (isEmail ? sanitizeEmailInput($event) : null))"
    >
    <input 
      *ngIf="isMoney"
      [id]="controlName"
      (focus)="onFocus()"
      (blur)="onBlur()"
      CurrencyFormatter
      [class.input-invalid]="form.get(controlName)?.invalid && form.get(controlName)?.touched" 
      [formControlName]="controlName" 
      type="text" 
      class="form-control"
      [ngClass]="{
        'icono-placeholder-image': form.get(controlName)?.invalid && form.get(controlName)?.touched,
        'text-invalid': form.get(controlName)?.invalid && form.get(controlName)?.touched
      }"
      [placeholder]="placeholder" 
      [readonly]="isReadOnly" 
      (keydown)="isNumberOnly ? validateNumber($event) : (isAlphaOnly ? validateAlpha($event) : null)" 
    > 
    <!-- Icono a la derecha -->
    <span *ngIf="iconClass" class="input-icon-right">
      <!-- <i [ngClass]="iconClass" (click)="generarEditar()"></i> -->
      <img [src]="iconClass" alt="icon-input"  (click)="generarEditar()">
    </span>
  </div>

  <div *ngIf="form.get(controlName)?.invalid && form.get(controlName)?.touched" class="text-danger danger-text">
    <small *ngIf="isValidField(controlName)" class="maxwithalert" style="font-size: 14px;">{{ getErrorMessage(controlName) }}</small>
  </div>
  <p *ngIf="message" class="InfoDatoinquilino">{{message}}</p>
</div>
